import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'htmlFormatter',
    standalone: false
})
export class HtmlFormatterPipe implements PipeTransform {

  transform(value: string, args: string[]): any {
    value = value.replace(/(?:\\r\\n|\\r|\\n)/g, '<br />');
    return '<span>' + value + '</span>';

  }

}
